import React from 'react';
import Navbar from '../layouts/navbar';
import './storyTypes.css';
import {Link} from 'react-router-dom'

const storyTypes=(props)=>{
    return(
        <div>
        <Navbar head="Stories Explore" link="/"/>
        <div className="container" style={{fontFamily:"'Open Sans',sans-serif",marginTop:"60px"}}>
            <div className="row mt-4 d-none d-md-block">
                <div className="col-12">
                    <h1 className="text-left" >We don't just carve paths, we walk you.<br></br>
                        Helped a few, will help you too!
                    </h1>
                    <p style={{fontSize:"1.2rem"}}>We call connection: an antidode to addiction! Let's build a few: here are a few, like me and you, let their stories be the first chapter to yours, let their reasons be one of yours.</p>
                </div>
                
            </div>
            <div className="row justify-content-center">
                <div className="col-12 col-md-4 my-4">
                    <Link to="/familystories/route">
                    <div className="card text-white">
                        <img className="card-img" src="/assests/images/familyStories.png" height="250" alt="">
                        </img>
                        <div className="card-img-overlay d-flex align-items-end">
                            <p style={{fontSize:"1.5rem"}}>Stories of Families</p>
                        </div>
                    </div>
                    </Link>
                </div>
                <div className="col-12 col-md-4 my-md-4">
                <Link to="/dependantstories/route">
                    <div className="card text-white">
                        <img className="card-img " src="/assests/images/dependent.jpg" height="250" alt="">
                        </img>
                        <div className="card-img-overlay d-flex align-items-end">
                            <p style={{fontSize:"1.5rem"}}>Stories of Dependants</p>
                        </div>
                    </div>
                </Link>
                </div>
            </div>
        </div>
        </div>
    )
}

export default storyTypes;